"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLengthOfFilteredValues = exports.getLastIndexOfFilteredValues = exports.getFirstIndexOfFilteredValues = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var formik_1 = require("formik");
var ArrayFieldMenu_1 = __importDefault(require("./ArrayFieldMenu"));
var getFirstIndexOfFilteredValues = function (values, filter) {
    if (!filter) {
        return 0;
    }
    if (!Array.isArray(values)) {
        return 0;
    }
    var filteredValues = values.filter(filter);
    return values.indexOf(filteredValues[0]);
};
exports.getFirstIndexOfFilteredValues = getFirstIndexOfFilteredValues;
var getLastIndexOfFilteredValues = function (values, filter) {
    if (!Array.isArray(values)) {
        return 0;
    }
    if (!filter) {
        return values.length - 1;
    }
    var filteredValues = values.filter(filter);
    return values.indexOf(filteredValues[filteredValues.length - 1]);
};
exports.getLastIndexOfFilteredValues = getLastIndexOfFilteredValues;
var getLengthOfFilteredValues = function (values, filter) {
    if (!filter) {
        return values.length;
    }
    return values.filter(filter).length;
};
exports.getLengthOfFilteredValues = getLengthOfFilteredValues;
function ArrayField(props) {
    var readOnly = props.readOnly, name = props.name, children = props.children, createEmptyValue = props.createEmptyValue, onlyOneValue = props.onlyOneValue, filter = props.filter;
    var _a = (0, formik_1.useFormikContext)(), values = _a.values, setFieldValue = _a.setFieldValue;
    var _b = __read((0, formik_1.useField)(name), 2), meta = _b[1];
    var error = meta.error;
    var firstIndex = (0, exports.getFirstIndexOfFilteredValues)(values[name], filter);
    var lastIndex = (0, exports.getLastIndexOfFilteredValues)(values[name], filter);
    return ((0, jsx_runtime_1.jsx)(formik_1.FieldArray, __assign({ name: name }, { children: function (_a) {
            var push = _a.push, remove = _a.remove;
            return ((0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "standard", error: !!error, fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(system_1.Stack, __assign({ spacing: 2 }, { children: values[name]
                        ? values[name].map(function (_, currentIndex) {
                            if (filter && !filter(values[name][currentIndex])) {
                                return null;
                            }
                            return (
                            // eslint-disable-next-line react/no-array-index-key
                            (0, jsx_runtime_1.jsxs)(system_1.Stack, __assign({ direction: "row" }, { children: [children(currentIndex), readOnly || onlyOneValue ? ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: { width: 49, minWidth: 49 } })) : ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { mt: 3, ml: 1 } }, { children: (0, jsx_runtime_1.jsx)(ArrayFieldMenu_1.default, { value: values[name][currentIndex], onlyOneValue: onlyOneValue, checkPrimary: function () {
                                                for (var i = 0; i < values[name].length; i += 1) {
                                                    setFieldValue("".concat(name, "[").concat(i, "].primary"), false);
                                                }
                                                setFieldValue("".concat(name, "[").concat(currentIndex, "].primary"), true);
                                            }, dropOrErase: function () {
                                                if (currentIndex === firstIndex &&
                                                    currentIndex === lastIndex) {
                                                    setFieldValue("".concat(name, "[").concat(currentIndex, "]"), createEmptyValue());
                                                }
                                                else {
                                                    remove(currentIndex);
                                                }
                                            }, pushNewElement: function () { return push(createEmptyValue()); } }) })))] }), currentIndex));
                        })
                        : null })) })));
        } })));
}
exports.default = ArrayField;
ArrayField.defaultProps = {
    onlyOneValue: false,
    filter: undefined,
    readOnly: false,
};
//# sourceMappingURL=ArrayField.js.map